module.exports = __webpack_public_path__ + "static/media/onda-fondo-rosa-rojo-aon.d367df11.png";